import { apiSlice } from '../../../store/apiSlice';

export interface ClientePayload {
  documento: string;
  telefono: string;
  apellido: string;
  nombre: string;
  direccion: string;
  localidad: string;
  provincia: string;
  pais: string;
  email?: string;
  facebook?: string;
  twitter?: string;
  instagram?: string;
  linkedin?: string;
  github?: string;
  condicion?: number;
  empresa_id: number;
  texto1?: string;
  texto2?: string;
  texto3?: string;
  texto4?: string;
  texto5?: string;
  texto6?: string;
  texto7?: string;
  texto8?: string;
  texto9?: string;
  texto10?: string;
  nombre_texto1?: string;
  nombre_texto2?: string;
  nombre_texto3?: string;
  nombre_texto4?: string;
  nombre_texto5?: string;
  nombre_texto6?: string;
  nombre_texto7?: string;
  nombre_texto8?: string;
  nombre_texto9?: string;
  nombre_texto10?: string;
  id1?: number;
  id2?: number;
  id3?: number;
  id4?: number;
  id5?: number;
}

export interface Cliente {
  id: number;
  documento: string;
  telefono: string;
  apellido: string;
  nombre: string;
  direccion: string;
  localidad: string;
  provincia: string;
  pais: string;
  email?: string;
  facebook?: string;
  twitter?: string;
  instagram?: string;
  linkedin?: string;
  github?: string;
  condicion?: number;
  empresa_id: number;
  texto1?: string;
  texto2?: string;
  texto3?: string;
  texto4?: string;
  texto5?: string;
  texto6?: string;
  texto7?: string;
  texto8?: string;
  texto9?: string;
  texto10?: string;
  nombre_texto1?: string;
  nombre_texto2?: string;
  nombre_texto3?: string;
  nombre_texto4?: string;
  nombre_texto5?: string;
  nombre_texto6?: string;
  nombre_texto7?: string;
  nombre_texto8?: string;
  nombre_texto9?: string;
  nombre_texto10?: string;
  id1?: number;
  id2?: number;
  id3?: number;
  id4?: number;
  id5?: number;
  created_at?: string;
  updated_at?: string;
}

export interface ClientesListResponse {
  data: Cliente[];
  total: number;
}

export const clientesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addCliente: builder.mutation<Cliente, ClientePayload>({
      query: (body) => ({
        url: '/clientes',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Cliente', id: 'LIST' }],
    }),
    getClientes: builder.query<
      ClientesListResponse, 
      { empresa_id?: number; search?: string; nombre?: string; apellido?: string; documento?: string; localidad?: string; telefono?: string; page?: number; limit?: number }
    >({
      query: (params) => {
        const query = new URLSearchParams();
        if (params.empresa_id) query.append('empresa_id', String(params.empresa_id));
        if (params.search) query.append('search', params.search);
        if (params.nombre) query.append('nombre', params.nombre);
        if (params.apellido) query.append('apellido', params.apellido);
        if (params.documento) query.append('documento', params.documento);
        if (params.localidad) query.append('localidad', params.localidad);
        if (params.telefono) query.append('telefono', params.telefono);
        if (params.page) query.append('page', String(params.page));
        if (params.limit) query.append('limit', String(params.limit));
        return `/clientes?${query.toString()}`;
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Cliente' as const, id })),
              { type: 'Cliente' as const, id: 'LIST' },
            ]
          : [{ type: 'Cliente' as const, id: 'LIST' }],
    }),
    updateCliente: builder.mutation<Cliente, Partial<Cliente> & { id: number }>({
      query: ({ id, ...body }) => ({
        url: `/clientes/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_, __, arg) => [
        { type: 'Cliente', id: arg.id },
        { type: 'Cliente', id: 'LIST' },
      ],
    }),
    deleteCliente: builder.mutation<{ success: boolean }, number>({
      query: (id) => ({
        url: `/clientes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => [
        { type: 'Cliente', id },
        { type: 'Cliente', id: 'LIST' },
      ],
    }),
    getValoresUnicos: builder.query<
      { localidad: string[]; provincia: string[]; pais: string[] },
      { empresa_id: number }
    >({
      query: ({ empresa_id }) => ({
        url: `/clientes/valores-unicos`,
        params: { empresa_id, campos: 'localidad,provincia,pais' },
      }),
    }),
    borrarCamposTexto: builder.mutation<
      { success: boolean; count: number },
      { empresa_id: number; campos: string[] }
    >({
      query: (payload) => ({
        url: `/clientes/borrar-campos`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: 'Cliente', id: 'LIST' }],
    }),
  }),
});

export const { 
  useAddClienteMutation, 
  useGetClientesQuery, 
  useUpdateClienteMutation, 
  useDeleteClienteMutation, 
  useGetValoresUnicosQuery,
  useBorrarCamposTextoMutation 
} = clientesApiSlice; 